import { render, staticRenderFns } from "./logo-infrastrukturdemontage.svg?vue&type=template&id=4cf63706"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports